export default {
  text: '#111',
  primary: '#ea6d00',
  secondary: '#BDA45D',
  background: '#fff',
  backgroundSecondary: 'black',
  light: '#FFF',
  dark: '#111'
}
